import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import {Contact, Despre_noi, Footer, Header, Servicii_inchinare, Conducere, Mapa /* , SarbatoareaMultumirii, Conferinta, Botez */ } from './containers';
import {CustomNavbar } from './components';
import './App.css'
// import Conferinta_2024 from './containers/conferinta_2024/conferinta_2024';
// import Botez_2024 from './containers/botez_2024/botez_2024';

const App = () => {
  document.title = "Biserica Penticostală Română Betel";

  return (
    <>
      <CustomNavbar/>
      <Header />
      <Despre_noi/>
      <Servicii_inchinare/>
      <Conducere/>
      {/* Galerie - ascunsa temporar
      <Conferinta />
      <SarbatoareaMultumirii />
      <Botez />
      <Conferinta_2024 />
      <Botez_2024 />
      */}
      <Contact/>
      <Mapa/>
      <Footer/>
    </>
  );
}

export default App